import { Injectable } from "@angular/core";
@Injectable()
export class ContactModel {
    public cust: string;
    public depot: number;
    public email: string;
    public fax: string;
    public id: number;
    public name: string;
    public phone: string;
    public _id: string;

    [x: string]: any;
}
